import React, { useState } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { broadcastNotification } from '../api';
import { toast } from 'sonner';
import { Bell, Send } from 'lucide-react';

export const AdminBroadcastPage = () => {
  const [form, setForm] = useState({ title: '', body: '', target: 'all' });
  const [sending, setSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!form.title || !form.body) { toast.error('Titre et message requis'); return; }
    if (!window.confirm(`Envoyer cette notification à "${form.target === 'all' ? 'tous les utilisateurs' : form.target}" ?`)) return;
    setSending(true);
    try {
      await broadcastNotification(form);
      toast.success('Notification envoyée !');
      setForm({ title: '', body: '', target: 'all' });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'envoi');
    } finally {
      setSending(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6 max-w-xl">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Notifications broadcast</h1>
          <p className="text-muted-foreground text-sm">Envoyer une notification à un groupe d'utilisateurs</p>
        </div>

        <form onSubmit={handleSend} className="bg-card border border-border rounded-xl p-6 space-y-5">
          <div>
            <label className="text-sm font-medium text-foreground block mb-1">Destinataires</label>
            <select
              className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              value={form.target}
              onChange={e => setForm(f => ({ ...f, target: e.target.value }))}
            >
              <option value="all">Tous les utilisateurs</option>
              <option value="creators">Créateurs uniquement</option>
              <option value="viewers">Viewers uniquement</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium text-foreground block mb-1">Titre *</label>
            <input
              className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Ex: Nouveauté YetuTv !"
              value={form.title}
              onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground block mb-1">Message *</label>
            <textarea
              className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
              rows={5}
              placeholder="Contenu de la notification..."
              value={form.body}
              onChange={e => setForm(f => ({ ...f, body: e.target.value }))}
            />
          </div>

          {/* Preview */}
          {(form.title || form.body) && (
            <div className="bg-muted/30 border border-border rounded-lg p-4 space-y-1">
              <p className="text-xs text-muted-foreground uppercase font-medium tracking-wide mb-2">Aperçu</p>
              <div className="flex items-start gap-3">
                <Bell className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-foreground">{form.title || '(titre)'}</p>
                  <p className="text-sm text-muted-foreground">{form.body || '(message)'}</p>
                </div>
              </div>
            </div>
          )}

          <button
            type="submit"
            disabled={sending}
            className="flex items-center gap-2 px-6 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 font-medium"
          >
            <Send className="w-4 h-4" />
            {sending ? 'Envoi en cours...' : 'Envoyer la notification'}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
};
